import React from 'react'
import navigationStamp from '../../../static/images/navigation.svg'
import capitalizeStatesInLocation from '../../../utils/capitalizeStatesInLocation'
import '../../styles/AdvisorCardsModule/AdvisorLocation.scss'

interface AdvisorLocationProps {
  location: string
  distance: string
}

export const AdvisorLocation = ({ location, distance }: AdvisorLocationProps) => (
  <div className='advisor-location'>
    <img src={navigationStamp} alt='navigation'/>
    <p className='advisor-location__distance'>
      {capitalizeStatesInLocation(location)} ({distance} away)
    </p>
  </div>
)
